module.exports = __webpack_public_path__ + "img/downArrow.3c9ffe07.svg";